import $ from "jquery";

$(function() {
  var trigger = $(".c-accordion").find(".c-accordion__title");

  trigger.click(function(e) {
    var accordionItem = $(this).parent(".c-accordion__item");

    if (!accordionItem.hasClass("c-accordion__item--active")) {
      closeAccordion(accordionItem.siblings(".c-accordion__item--active"));
      openAccordion(accordionItem);
    } else {
      closeAccordion(accordionItem);
    }

    function openAccordion(accordionItem) {
      var contentContainer = accordionItem.find(
        ".c-accordion__content-container"
      );
      var content = accordionItem.find(".c-accordion__content");
      var contentHeight = content.outerHeight(true);

      accordionItem.addClass("animate");
      contentContainer.css("height", contentHeight);

      setTimeout(function() {
        accordionItem.addClass("c-accordion__item--active");
      }, 100);
      setTimeout(function() {
        accordionItem.removeClass("animate");
      }, 200);
      setTimeout(function() {
        contentContainer.css("height", "");
      }, 600);
    }

    function closeAccordion(accordionItem) {
      var contentContainer = accordionItem.find(
        ".c-accordion__content-container"
      );
      var content = accordionItem.find(".c-accordion__content");
      var contentHeight = content.outerHeight(true);

      contentContainer.css("height", contentHeight);

      setTimeout(function() {
        accordionItem
          .addClass("animate")
          .removeClass("c-accordion__item--active");
      }, 10);
      setTimeout(function() {
        contentContainer.css("height", 0);
      }, 20);
      setTimeout(function() {
        accordionItem.removeClass("animate");
      }, 600);
      setTimeout(function() {
        contentContainer.css("height", "");
      }, 700);
    }

    e.preventDefault();
  });
});
